module.exports = __webpack_public_path__ + "media/img/logo_cuk-a41fb721.png";